import React, { useEffect, useState } from "react";
import "./Billboards.css";
import NavBar from "./NavBar";
import Footer from "./Footer";
import api from "./Dashboard/Api";
import Filters from "./Filter"; // استيراد مكون الفلتر الجديد

const Billboards = () => {
  const [allBillboards, setAllBillboards] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [addressFilter, setAddressFilter] = useState("");
  const [availability, setAvailability] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [selectedBillboard, setSelectedBillboard] = useState(null);
  const [showBookingForm, setShowBookingForm] = useState(false);
  const [bookingData, setBookingData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      setError(null);
      try {
        const [bResp, aResp] = await Promise.all([
          api.get("/shared/api/billboards", {
            params: { page: 1, pageSize: 1000 },
          }),
          api.get("/api/admin/address/GetAll"),
        ]);

        const billboardsData = bResp.data?.data || [];
        setAllBillboards(billboardsData);

        const addressesData = Array.isArray(aResp.data)
          ? aResp.data
          : aResp.data?.data || [];
        setAddresses(addressesData || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load data from server.");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  useEffect(() => {
    let list = [...allBillboards];

    if (addressFilter) {
      list = list.filter(
        (b) =>
          (b.address?.name || "").toLowerCase() === addressFilter.toLowerCase()
      );
    }

    if (availability === "available") {
      list = list.filter((b) => b.isAvailable === true);
    } else if (availability === "booked") {
      list = list.filter((b) => b.isAvailable === false);
    }

    setFiltered(list);
    setCurrentPage(1);
  }, [allBillboards, addressFilter, availability]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / itemsPerPage));
  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [totalPages, currentPage]);

  const currentItems = filtered.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const openModal = (b) => {
    setSelectedBillboard(b);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setSelectedBillboard(null);
    document.body.style.overflow = "auto";
  };

  const openBooking = (b) => {
    setSelectedBillboard(b);
    setShowBookingForm(true);
    document.body.style.overflow = "hidden";
  };

  const closeBooking = () => {
    setShowBookingForm(false);
    setSelectedBillboard(null);
    document.body.style.overflow = "auto";
    setBookingData({ name: "", phone: "", email: "", message: "" });
  };

  const handleBookingChange = (e) => {
    const { name, value } = e.target;
    setBookingData((p) => ({ ...p, [name]: value }));
  };

  const submitBooking = async (e) => {
    e.preventDefault();
    if (!selectedBillboard) return;

    const payload = {
      Name: bookingData.name,
      Email: bookingData.email,
      Phone: bookingData.phone,
      Message: bookingData.message,
      BillboardId: selectedBillboard.id,
    };

    try {
      setLoading(true);
      const resp = await api.post(
        "/shared/api/billboards/SubmitContactForm",
        payload
      );
      if (resp.data?.success) {
        setSuccessMessage(
          "Your request has been sent successfully. We will contact you soon."
        );
      } else {
        setSuccessMessage("Request sent (server response not confirmed).");
      }
      setTimeout(() => setSuccessMessage(""), 5000);
      closeBooking();
    } catch (err) {
      console.error("Booking submit error:", err);
      alert(
        "An error occurred while sending the request. Please check the console."
      );
    } finally {
      setLoading(false);
    }
  };

  // الأيقونات العادية كرموز نصية
  const icons = {
    eye: "👁️",
    location: "",
    chart: "📊",
    ruler: "📏",
    road: "🛣️",
    light: "💡",
    calendar: "📅",
  };

  return (
    <div className="billboards-page">
      <NavBar />
      <section className="billboards-hero">
        <div className="billboards-hero-content container">
          <h1>Spark Billboard Network</h1>
          <p>Premium outdoor advertising spaces for maximum brand visibility</p>
          <div className="billboards-hero-stats">
            <div className="billboards-hero-stat">
              <span className="stat-icon">{icons.eye}</span>
              <span>30M+ Daily Impressions</span>
            </div>
            <div className="billboards-hero-stat">
              <span className="stat-icon">{icons.location}</span>
              <span>200+ Strategic Locations</span>
            </div>
            <div className="billboards-hero-stat">
              <span className="stat-icon">{icons.chart}</span>
              <span>95% Audience Reach</span>
            </div>
          </div>
        </div>
        <div className="billboards-hero-overlay"></div>
      </section>
      
      <div className="container controls-wrap">
        <Filters
          addresses={addresses}
          addressFilter={addressFilter}
          setAddressFilter={setAddressFilter}
          availability={availability}
          setAvailability={setAvailability}
        />
      </div>
      
      <main className="container billboards-container">
        {loading ? (
          <div className="spinner">Loading...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : filtered.length === 0 ? (
          <div className="empty">No billboards match your filters.</div>
        ) : (
          currentItems.map((b) => (
            <article className="billboard-card" key={b.id}>
              <div className="card-image">
                <img
                  src={b.imageUrl}
                  alt={b.description || "Billboard"}
                  onError={(e) => {
                    e.target.onerror = null;
                  }}
                />
                <span
                  className={`availability-badge ${
                    b.isAvailable ? "available" : "unavailable"
                  }`}
                >
                  {b.isAvailable ? "Available" : "Booked"}
                </span>
              </div>

              <div className="card-content">
                <div className="card-header">
                  <h4>{b.description}</h4>
                  <span className="code">{b.code}</span>
                </div>

                <p className="billboard-description">
                  {b.subDescription ||
                    "Premium advertising space in high-traffic area"}
                </p>

                <div className="billboard-details">
                  <div className="detail-row">
                    <span className="detail-label">Size:</span>
                    <span className="detail-value">{b.size || "N/A"}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Address:</span>
                    <span className="detail-value">
                      {b.address?.name || b.location || "N/A"}
                    </span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Highway:</span>
                    <span className="detail-value">{b.highway || "N/A"}</span>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    className="view-details-btn"
                    onClick={() => openModal(b)}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </article>
          ))
        )}
      </main>
      
      <div className=" pagination-wrap">
        <button
          className="pagination-btn"
          onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
          disabled={currentPage === 1}
        >
          ‹ Previous
        </button>

        <span className="page-info">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className="pagination-btn"
          onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
          disabled={currentPage === totalPages}
        >
          Next ›
        </button>
      </div>
      
      {selectedBillboard && !showBookingForm && (
        <div className="modal-overlay" onClick={closeModal}>
          <button className="close-modal" onClick={closeModal}>
            ✕
          </button>

          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-image-full">
              <img
                src={selectedBillboard.imageUrl}
                alt={selectedBillboard.description}
                onError={(e) => {
                  e.target.onerror = null;
                }}
              />
              <span
                className={`modal-badge ${
                  selectedBillboard.isAvailable ? "available" : "unavailable"
                }`}
              >
                {selectedBillboard.isAvailable ? "Available" : "Booked"}
              </span>
            </div>

            <div className="modal-details-scroll">
              <h2 className="modal-description">
                {selectedBillboard.description}
                <span className="code"> {selectedBillboard.code}</span>
              </h2>
              <p className="modal-sub-description">
                {selectedBillboard.subDescription}
              </p>

              <div className="details-grid">
                <div className="detail-item">
                  <span className="detail-label">Size:</span>
                  <span className="detail-value">{selectedBillboard.size}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Type:</span>
                  <span className="detail-value">
                    {selectedBillboard.type || "N/A"}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Address:</span>
                  <span className="detail-value">
                    {selectedBillboard.address?.name ||
                      selectedBillboard.location ||
                      "N/A"}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Highway:</span>
                  <span className="detail-value">
                    {selectedBillboard.highway || "N/A"}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Code:</span>
                  <span className="detail-value">
                    {selectedBillboard.code || "N/A"}
                  </span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Faces:</span>
                  <span className="detail-value">
                    {selectedBillboard.numberOfFaces ?? "N/A"}
                  </span>
                </div>
              </div>

              <div className="availability">
                {selectedBillboard.isAvailable ? (
                  <p className="availability-text">
                    <strong>Currently Available for Booking</strong>
                  </p>
                ) : (
                  <div className="availability-dates">
                    <p className="availability-text">
                      <strong>Currently booked</strong>
                    </p>
                    <div className="date-range">
                      <div className="date-from">
                        <span className="date-label">From:</span>{" "}
                        <span className="date-value">
                          {selectedBillboard.startBooking
                            ? new Date(
                                selectedBillboard.startBooking
                              ).toLocaleDateString()
                            : "-"}
                        </span>
                      </div>
                      <div className="date-to">
                        <span className="date-label">To:</span>{" "}
                        <span className="date-value">
                          {selectedBillboard.endBooking
                            ? new Date(
                                selectedBillboard.endBooking
                              ).toLocaleDateString()
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-buttons">
                <button
                  className={`book-now-btn-modal ${
                    !selectedBillboard.isAvailable ? "disabled-btn" : ""
                  }`}
                  onClick={() => {
                    closeModal();
                    openBooking(selectedBillboard);
                  }}
                >
                  {selectedBillboard.isAvailable
                    ? "Book Now"
                    : "Inquire About Booking"}
                </button>
                <a
                  className="view-on-map-btn"
                  href={selectedBillboard.locationURL || "#"}
                  target="_blank"
                  rel="noreferrer"
                >
                  View on Map
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {showBookingForm && selectedBillboard && (
        <div className="modal-overlay" onClick={closeBooking}>
          <div
            className="compact-form-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="compact-form-card">
              <button className="close-compact-form" onClick={closeBooking}>
                ✕
              </button>
              <div className="compact-form-header">
                <h2>Booking Request</h2>
                <p>
                  {selectedBillboard.description} ({selectedBillboard.code})
                </p>
              </div>

              <form className="compact-form" onSubmit={submitBooking}>
                <div className="input-with-floating-label">
                  <input
                    className="floating-input"
                    placeholder=" "
                    name="name"
                    value={bookingData.name}
                    onChange={handleBookingChange}
                    required
                  />
                  <label className="floating-label">Full Name *</label>
                </div>

                <div className="input-with-floating-label">
                  <input
                    className="floating-input"
                    placeholder=" "
                    name="phone"
                    value={bookingData.phone}
                    onChange={handleBookingChange}
                    required
                  />
                  <label className="floating-label">Phone Number *</label>
                </div>

                <div className="input-with-floating-label">
                  <input
                    className="floating-input"
                    placeholder=" "
                    name="email"
                    type="email"
                    value={bookingData.email}
                    onChange={handleBookingChange}
                    required
                  />
                  <label className="floating-label">Email Address *</label>
                </div>

                <div className="input-with-floating-label textarea-container">
                  <textarea
                    className="floating-input floating-textarea"
                    placeholder=" "
                    name="message"
                    value={bookingData.message}
                    onChange={handleBookingChange}
                    rows="4"
                  />
                  <label className="floating-label">
                    Additional Message (Optional)
                  </label>
                </div>

                <div className="compact-form-buttons">
                  <button
                    type="button"
                    className="cancel-compact-btn"
                    onClick={closeBooking}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="submit-compact-btn">
                    Submit Request
                  </button>
                </div>

                {successMessage && (
                  <div className="success-msg">{successMessage}</div>
                )}
              </form>
            </div>
          </div>
        </div>
      )}
      
      <Footer />
    </div>
  );
};

export default Billboards;